import * as React from 'react';
import { LoginResult } from '../types/types';

export const useIFrameAuth = (popupOrigin: string) => {
    const ref: React.MutableRefObject<HTMLIFrameElement | undefined> = React.useRef();

    // Create iframe
    React.useEffect(() => {
        const iframe = document.createElement('iframe');
        iframe.src = process.env.AUTH_FRAME_URL! + `?origin=${popupOrigin}`;
        iframe.style.display = 'none';

        ref.current = iframe;

        document.body.appendChild(iframe);

        return () => {
            document.body.removeChild(iframe);
        };
    }, []);

    const authOrigin = process.env.AUTH_FRAME_URL!.split('/').slice(0, 3).join('/');

    const sendRequest = (type: 'login' | 'signup', { username, password }: { username: string; password: string }) => {
        return new Promise<LoginResult>((resolve, reject) => {
            const eventHandler = new MessageEventHandler(resolve, reject);

            window.addEventListener('message', eventHandler, false);

            ref.current?.contentWindow?.postMessage({ event: `${type}.request`, username, password }, authOrigin);

            return () => {
                window.removeEventListener('message', eventHandler);
            };
        });
    };

    const signup = (username: string, password: string) => sendRequest('signup', { username, password });

    const login = (username: string, password: string) => sendRequest('login', { username, password });

    return { signup, login };
};

class MessageEventHandler {
    constructor(private resolve: (data: { accessToken: string }) => void, private reject: (reason?: string) => void) {}

    handleEvent({ data, origin }: any) {
        if (process.env.APP_ORIGIN !== '*' && origin !== process.env.APP_ORIGIN) {
            return;
        }

        if (typeof data === 'object') {
            switch (data.event) {
                case 'login.success':
                    return this.resolve({ accessToken: data.accessToken });
                case 'login.error':
                case 'signup.error':
                    return this.reject(data.error);
            }
        }
    }
}
